// Página de visualización de perfil de otro usuario
import React from "react";
import ProfileUserComponent from "../components/ProfileUserComponent"; // la versión solo lectura
import { useParams } from "react-router-dom"; // para leer userId de la URL

const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:3005";

export default function ProfileUserPageView() {
  const { userId } = useParams(); // suponemos que la ruta es /profile/:userId
  const [profileData, setProfileData] = React.useState(null);
  const [companiesData, setCompaniesData] = React.useState([]);
  const [projectsData, setProjectsData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token"); // opcional: si necesitas auth
      if (!token) {
        alert("No estás autenticado. Por favor, inicia sesión.");
        window.location.href = "/";
        return;
      }

      try {
        setLoading(true);
        console.log("Fetching profile for userId:", userId);
        const response = await fetch(`${baseUrl}/users/${userId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log("Response data:", data);

        if (!response.ok) {
          alert(data.message || "Error al obtener el perfil");
          window.location.href = "/";
          return;
        }

        setProfileData(data);

        // Recuperamos las empresas aceptadas
        if (data.companies && data.companies.length > 0) {
          const companies = await Promise.all(
            data.companies.map(async (company) => {
              console.log("Fetching company for companyId:", company.companyId);

              const res = await fetch(`${baseUrl}/company/${company.companyId}`, {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });

              const companyData = await res.json();

              return {
                ...companyData,
                role: company.role,
              };
            })
          );

          // Una referencia a algo ya borrado responde 404 { message }: sin _id no se pinta
          setCompaniesData(companies.filter((c) => c._id && c.accepted !== false));
        } else {
          setCompaniesData([]);
        }

        // Recuperamos los proyectos aceptados
        if (data.projects && data.projects.length > 0) {
          const projects = await Promise.all(
            data.projects.map(async (project) => {
              console.log("Fetching project for projectId:", project.projectId);

              const res = await fetch(`${baseUrl}/project/${project.projectId}`, {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });

              const projectData = await res.json();

              return {
                ...projectData,
                role: project.role,
              };
            })
          );

          setProjectsData(projects.filter((p) => p._id && p.accepted !== false));
        } else {
          setProjectsData([]);
        }
      } catch (error) {
        console.error("Error en la petición:", error);
        alert("Error de conexión con el servidor");
      }
      finally {
        setLoading(false);
      }
    };


    if (userId) fetchProfile();
  }, [userId]);

  const enviarMensaje = async (messageData, email) => {
    // Lógica para enviar el mensaje (por ejemplo, una llamada a la API)
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/sendEmail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({
          to: profileData.email,
          from : email,
          message: messageData
        })
      });
      console.log(res);
      if (res.ok) {
        console.log("Mensaje enviado correctamente");
      } else {
        console.error('Error enviando mensaje:', res.statusText);
      }
    } catch (err) {
      console.error('Error enviando mensaje:', err);
    }
  };

  return React.createElement(ProfileUserComponent, {
    profile: profileData,
    companies: companiesData,
    projects: projectsData,
    enviarMensaje: enviarMensaje,
    loading: loading
  });
};
